import { render, staticRenderFns } from "./sound-index.vue?vue&type=template&id=2a5caf15&scoped=true&"
import script from "./sound-index.vue?vue&type=script&lang=js&"
export * from "./sound-index.vue?vue&type=script&lang=js&"
import style0 from "./sound-index.vue?vue&type=style&index=0&id=2a5caf15&prod&lang=css&"
import style1 from "./sound-index.vue?vue&type=style&index=1&id=2a5caf15&prod&scoped=true&lang=css&"
import style2 from "./sound-index.vue?vue&type=style&index=2&id=2a5caf15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5caf15",
  null
  
)

export default component.exports